<script lang="ts">
  export let stopInfo;
  export let nextShuttle;
  export let formatEta;
  export let otherShuttle;
  export let lang
  const convertTimeTo24HR = (str) => {
    if (!str) { return "..."}
    let [hour,minuteAndSuffix] = str.split(":")
    if (!minuteAndSuffix) { return "..."}
    const [minute, suffix] = minuteAndSuffix.split(" ")

    if (suffix.toLowerCase() === "pm") {
      if (hour != "12") {
      hour = Number(hour) + 12
      }
    }
    return `${hour}:${minute}`
  }
</script>

<div class="bg-white _w-full d-flex flx-jspace p-2">
  <div class="location">
    <div class="txt-dark-900">{stopInfo.name}</div>
    <div class="txt-dark-800">{stopInfo.address}</div>
  </div>
  <div class="time txt-right">
    <div class="txt-dark-900 heading6 eta">
      {nextShuttle.eta}
    </div>
    <div class="txt-dark-900 time">{lang === "en" ? nextShuttle.time : convertTimeTo24HR(nextShuttle.time)}</div>
  </div>
</div>